
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/author/[authorSlug]",
      function () {
        return require("private-next-pages/blog/author/[authorSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/author/[authorSlug]"])
      });
    }
  